import { UsuarioService } from 'src/app/shared/services/usuario/usuario.service';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import {Usuario} from '../../../models/usuario.interface';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  menu = [];

  @Input()
  imagemUsuario: string;

  @Input()
  role = '';

  tema = '';

  hoverColor = '#bbb';

  constructor(
    private readonly router: Router,
    private usuarioService: UsuarioService
  ) {
    const usr: Usuario = JSON.parse(window.localStorage.getItem('usuario'));
    this.tema = usr.temaModelo;
  }

  ngOnInit(): void {
    this.loadMenu();
  }


  loadMenu() {
    if (this.role === 'ROLE_ADMIN') {
      this.menu.push({ nome: 'Indicadores', icon: 'query_stats', rota: `` });
      this.menu.push({ nome: 'Empresa', icon: 'storefront', rota: 'empresas' });
      this.menu.push({ nome: 'Usuários', icon: 'group', rota: 'usuarios' });
      this.menu.push({ nome: 'Configuração', icon: 'settings', rota: 'configuracao' });
    } else if (this.role === 'ROLE_MASTER') {
      this.menu.push({ nome: 'Indicadores', icon: 'query_stats', rota: `` });
      this.menu.push({ nome: 'Agenda', icon: 'calendar_month', rota: 'master/agenda' });
      this.menu.push({ nome: 'Fornecedores', icon: 'group_add', rota: 'master/fornecedores' });
      this.menu.push({ nome: 'Estoque', icon: 'store', rota: 'master/produtos' });
      this.menu.push({ nome: 'Vendas', icon: 'receipt_long', rota: 'master/vendas' });
      this.menu.push({ nome: 'Caixa', icon: 'payments', rota: 'master/caixa' });
      this.menu.push({ nome: 'Funcionários', icon: 'group', rota: 'master/funcionarios' });
      this.menu.push({ nome: 'Clientes', icon: 'person', rota: 'master/clientes' });
      this.menu.push({ nome: 'Configurações', icon: 'settings', rota: 'master/configuracao' });
    } else {
      this.menu.push({ nome: 'Início', icon: 'home', rota: `` });
      // this.menu.push({ nome: 'Minhas Comissões', icon: 'payments', rota: 'user/minhas-vendas' });
      this.menu.push({ nome: 'Realizar Venda', icon: 'storefront', rota: 'user/realizar-venda' });
      this.menu.push({ nome: 'Clientes', icon: 'person', rota: 'user/clientes' });
      this.menu.push({ nome: 'Configuração', icon: 'settings', rota: 'user/configuracao' });
    }
  }

  logoutSistem() {
    window.localStorage.removeItem('usuario');
    this.usuarioService.removeTk();
    this.router.navigate(['/login']);
  }

  navegar(rota: string) {
    this.router.navigate([`/${rota}`]);
  }



}
